import { jwtDecode } from "jwt-decode";
import { getTokens, setTokenFor } from "./tokenStore";
import {
  fetchRefreshToken,
  fetchProfileRefreshToken,
} from "../components/api/api";

let intervalId = null;

const isExpiringSoon = (accessToken, thresholdMs = 2 * 60 * 1000) => {
  try {
    const { exp } = jwtDecode(accessToken);
    const expiresAt = exp * 1000;
    return Date.now() + thresholdMs >= expiresAt;
  } catch {
    return true;
  }
};

export const startTokenAutoRefresh = (periodMs = 5 * 60 * 1000) => {
  if (intervalId) return; // already started
  intervalId = setInterval(async () => {
    const tokens = getTokens();
    let refreshed = false;

    // Main system token
    if (
      tokens.main?.accessToken &&
      tokens.main?.refreshToken &&
      isExpiringSoon(tokens.main.accessToken)
    ) {
      try {
        const decoded = jwtDecode(tokens.main.accessToken);
        const res = await fetchRefreshToken(
          tokens.main,
          decoded.email || decoded.userName
        );
        if (res?.data?.accessToken || res?.data?.data?.accessToken) {
          setTokenFor("main", res);
          refreshed = true;
        }
      } catch (e) {
        // ignore
      }
    }

    // Profile system token
    if (
      tokens.profile?.accessToken &&
      tokens.profile?.refreshToken &&
      isExpiringSoon(tokens.profile.accessToken)
    ) {
      try {
        const decoded = jwtDecode(tokens.profile.accessToken);
        const data = await fetchProfileRefreshToken(
          tokens.profile,
          decoded.userName || decoded.email
        );
        if (data?.accessToken || data?.data?.accessToken) {
          setTokenFor("profile", data);
          refreshed = true;
        }
      } catch (e) {
        // ignore
      }
    }

    if (refreshed) {
      // Notify the app that tokens were refreshed
      const evt = new Event("tokens-refreshed");
      window.dispatchEvent(evt);
    }
  }, periodMs);
};

export const stopTokenAutoRefresh = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};

export default {
  startTokenAutoRefresh,
  stopTokenAutoRefresh,
};